<template>
  <div class="export-dialog">
    <!-- 匹配订单护照页-->
    <el-dialog :visible.sync="dialogShow" width="1500px" :close-on-click-modal="true" @closed="handleClosed">
      <div class="dialog-member-title">
        <span class="dialog-member-name">批量导出订单</span>
        <div class="dialog-close" @click="closeFn">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div v-loading="loading">
        <div class="dialog-member-content">
          共查询到 {{ dataList.length }} 条数据
        </div>
        <VirtualTable ref="virtualTableRef" :table-data="dataList" :table-height="400" :row-height="48" :row-key="'id'"
          :checkedIds="checkedIds" @selection-change="handleSelectionChange">
          <template slot="columns">
            <el-table-column prop="" label="合作客户" width="140">
              <template slot-scope="scope">
                <div>{{ scope.row.coreCustomerInfo ? scope.row.coreCustomerInfo.companyName : '--' }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="商户信息" width="140">
              <template slot-scope="scope">
                <div>{{ scope.row.merchatInfo ? scope.row.merchatInfo.companyName : '--' }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="orderNo" label="订单号" width="100">
            </el-table-column>
            <el-table-column prop="payableAmount" label="订单金额" min-width="80">
            </el-table-column>
            <el-table-column prop="paidAmount" label="订单实收" min-width="80">
            </el-table-column>
            <el-table-column prop="paidAmount" label="订单未收" min-width="80">
              <template slot-scope="scope">
                <div>{{ scope.row.payableAmount - scope.row.paidAmount }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="visaLegend" label="国家-类型" min-width="150">
              <template slot-scope="scope">
                <p>{{ scope.row.countryName }}</p>
                <p>{{ scope.row.visaTypeName }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="visaTitle" label="产品名称" min-width="160">
              <template slot-scope="scope">
                <p>{{ scope.row.visaTitle }}</p>
                <div v-if="scope.row.marks">
                  <el-tooltip placement="top" :content="scope.row.marks">
                    <div class="marks-text" style="color: #e41313;">{{ scope.row.marks }} </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="statusName" label="订单状态" width="100">
              <template slot-scope="scope" @click.stop>
                <el-tag :type="setStatus(scope.row.status)" size="small"> {{ scope.row.statusName }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="userName" label="来源" class="kaka" min-width="180">
              <!-- orderSource  0：商户 1：平台 2:用户 3:API接口 -->
              <template slot-scope="scope">
                <div>
                  <div>
                    {{ scope.row.appName }}
                    <span v-if="scope.row.appType.indexOf('微信') > -1" class="source-type"
                      style="padding: 2px 4px;background-color: #168743;"> 微 </span>
                    <span v-else-if="scope.row.appType.indexOf('支付宝') > -1" class="source-type"
                      style="padding: 2px 4px;background-color: #0085ff;"> 支</span>
                    <span v-else-if="scope.row.appType" class="source-type"
                      style="padding: 2px 4px;background-color: #ff6c37;"> {{ scope.row.appType }}
                    </span>
                  </div>
                  <div>
                    {{ scope.row.merchatInfo && scope.row.merchatInfo.companyName || '--' }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="contacts" label="联系人信息" min-width="120px">
                            <template slot-scope="scope">
                                <span class="source-type" :style="{
                                    background: setOrderSourceColor(scope.row.orderSource),
                                }">{{ setOrderSourceText(scope.row.orderSource) }}</span>
                                <span>{{ scope.row.contacts ? scope.row.contacts : "--" }}</span><br />
                                <span>{{
                                    scope.row.contactPhone ? scope.row.contactPhone : "--"
                                }}</span>
                                <div v-if="scope.row.wechatName" :title="scope.row.wechatName"
                                    style="transform: scale(0.6);transform-origin: left;white-space: nowrap;">{{
                                        scope.row.wechatName }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="serviceMarks" label="操作备注" min-width="100">
                            <template slot-scope="scope">
                                <div>
                                    <div v-if="scope.row.marks">
                                        <el-tooltip placement="top" :content="scope.row.marks">
                                            <div class="marks-text" style="color: #e41313;">{{ scope.row.marks }} </div>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </template>
                        </el-table-column> -->
          </template>
        </VirtualTable>
        <div class="dialog-member-content">
          <el-button type="primary" @click="handleExportSelect">批量导出</el-button>
          <el-button @click="closeFn">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 收款对话框 -->
    <el-dialog :visible.sync="visibleAddReceive" width="500px" :close-on-click-modal="true" title="收款">
      <div class="dialog-member-title">
        <span class="dialog-member-name">批量收款</span>
      </div>
      <div class="add-receive-container">
        <el-form :model="addReceiveForm" :rules="addReceiveFormRules" ref="addReceiveFormRef" label-width="100px" size="small">
          <el-form-item label="金额:" prop="amount">
            <div>{{ allPrice }}</div>
          </el-form-item>
          <el-form-item label="账户:" prop="accountId">
            <el-select v-model="addReceiveForm.accountId" placeholder="未选择" size="small" style="width:100%;">
              <el-option v-for="item in accountList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input rows="2" type="textarea" v-model="addReceiveForm.remark" placeholder="备注"></el-input>
          </el-form-item>
          <el-form-item label="快照:">
            <upload v-model="addReceiveForm.imgUrl" accept="img" :auto-upload="true"
              :image-url="addReceiveForm.imgUrl" :drag="'drag'" thisType="custom" @input="toImg($event, 'imgUrl')"
              :customSty="{ width: '320px', height: '154px' }">
            </upload>
          </el-form-item>
        </el-form>
      </div>
      <span style="display: flex; justify-content: right;">
        <el-button @click="visibleAddReceive = false">取消</el-button>
        <el-button type="primary" @click="saveAddReceive">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { batchimportapplicant } from "@/api/order";
import { queryorderorg } from "@/api/orderCenter";
import { export_json_to_excel } from '@/utils/Export2Excel';
import VirtualTable from "./VirtualTable.vue";
import { addretransactionrecord, getQueryaccount,batchaddretransactionrecord } from '@/api/finance';
import upload from '@/components/upload.vue';
import time1 from "@/assets/images/order/time1.png";
export default {
  name: "orderDownloadDialog",
  computed: {
    allPrice(){
      if(this.selectedItems.length==0){
        return 0
      }
      let num=0
      console.log(this.selectedItems);
      
      this.selectedItems.forEach(item=>{
        num+=Number(item.currentAmount) ? Number(item.currentAmount) : 0
      })
      return num.toFixed(2).replace(/\.?0+$/, '')
    },
    price() {
      return (item) => {
        let priceNum = item.paidAmount - item.refundAmount;
        // 保留两位小数并且小数点后无零则不显示小数点
        if((item.payableAmount-item.paidAmount)>0){
          return `${item.payableAmount}/${item.paidAmount}`
        }
        return priceNum.toFixed(2).replace(/\.?0+$/, '');
      }
    },
    formatTime2() {
      return (value) => {
        return this.$moment(value).format("YY-MM-DD");
      };
    },
    formatTime() {
      return (value) => {
        return this.$moment(value).format("YY-MM-DD HH:mm");
      };
    },
    setStatus() {
      return function (status) {
        if (status == -4 || status == -2 || status == -3 || status == 2 || status == -1) {
          return "danger";
        } else if ([6, 7, 8].indexOf(status) > -1) {
          return "success";
        } else {
          return "warning";
        }
      };
    },
    setOrderSourceText() {
      return function (num) {
        let str = "";
        switch (num) {
          case 0:
            str = "商";
            break;
          case 1:
            str = "平";
            break;
          case 2:
            str = "用";
            break;
          default:
            str = "接";
        }
        return str;
      };
    },
    setOrderSourceColor() {
      return function (num) {
        let str = "";
        switch (num) {
          case 0:
            str = "#4791EA";
            break;
          case 1:
            str = "#49BD49";
            break;
          case 2:
            str = "#F79534";
            break;
          default:
            str = "#EA4747";
        }
        return str;
      };
    }
  },
  data() {
    return {
      time1,
      dialogShow: false,
      loading: false,
      dataList: [],
      checkedIds: [],
      virtualTableRef: null,
      visibleAddReceive: false,
      addReceiveForm: {
        amount: '',
        accountId: '',
        remark: '',
        imgUrl: '',
      },
      addReceiveFormRules: {
        amount: [
          // { required: true, message: '请输入金额', trigger: 'blur' },
          // { pattern: /^\d+(\.\d+)?$/, message: '请输入有效的数字金额', trigger: 'blur' }
        ],
        accountId: [
          { required: true, message: '请选择账户', trigger: 'change' }
        ],
      },
      accountList: [],
      selectedItems: [],
    };
  },
  components: {
    VirtualTable,
    upload
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formDate: {
      type: Object,
      default: () => ({})
    },
    PlanVisaDateTime: {
      type: Array,
      default: () => ([])
    },
    dateInfo: {
      type: Array,
      default: () => ([])
    },
  },
  watch: {
    visible(val) {
      this.dialogShow = val;
      if (val) {
        console.log('visible', val);
        console.log(this.formDate, this.PlanVisaDateTime, this.dateInfo)
        this.handleGetFailData()
        this.selectedItems=[]
      }
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedItems = val
    },
    closeFn() {
      this.$emit('close')
    },
    handleClosed() {
      // 清除数据
      this.dataList = []
      this.checkedIds = []
      this.$emit('close')
    },
    // 获取失败数据
    handleGetFailData() {
      this.loading = true
      let tempData = { ...this.formDate }
      let data = {
        ...tempData,
        "Page.Size": tempData.pageSize,
        "Page.Index": tempData.pageIndex
      }
      if (!this.PlanVisaDateTime) {
        tempData.PlanVisaStartTime = "";
        tempData.PlanVisaEndTime = "";
      } else {
        tempData.PlanVisaStartTime = this.PlanVisaDateTime[0];
        tempData.PlanVisaEndTime = this.PlanVisaDateTime[1];
      }
      if (!this.dateInfo) {
        tempData.StartTime = "";
        tempData.EndTime = "";
      } else {
        tempData.StartTime = this.dateInfo[0];
        tempData.EndTime = this.dateInfo[1];
      }
      queryorderorg(data).then(res => {
        console.log(res)
        if (res.code == 1) {
          this.dataList = res.data.row.map(item => {
            return {
              ...item,
              birthDay: item.birthDay ? this.$moment(item.birthDay).format('YYYY-MM-DD') : '',
              passportValidity: item.passportValidity ? this.$moment(item.passportValidity).format('YYYY-MM-DD') : '',
              passportIssue: item.passportIssue ? this.$moment(item.passportIssue).format('YYYY-MM-DD') : '',
              currentAmount: item.payableAmount - item.paidAmount,

            }
          })
        }
      }).finally(() => {
        this.loading = false;

      })
    },
    submitSelectionUpload() {
      this.exportMethod(this.dataList)
      this.$message.success(`正在导出 ${this.dataList.length} 条数据`)

    },
    handleExporetSelect() {
      const selection = this.$refs.virtualTableRef.getSelection()
      console.log('选中收款数据:', selection)
      if (selection.length == 0) {
        this.$message.error('请选择要收款的申请人')
        return
      }
      this.selectedItems = selection;
      this.visibleAddReceive = true;
    },
    handleExportSelect() {
      const selection = this.$refs.virtualTableRef.getSelection()
      if (selection.length == 0) {
        this.$message.error('请选择要导出的订单')
        return
      }
      this.selectedItems = selection;
      this.exportExcel();
    },
    exportExcel() {
      if (this.selectedItems.length == 0) {
        return this.$message.error('请选择要导出的订单')
      }
      let exportData = JSON.parse(JSON.stringify(this.selectedItems));
      exportData = exportData.map(item => {
        item.customerName = item.coreCustomerInfo ? item.coreCustomerInfo.companyName : '--';
        item.merchantName = item.merchatInfo ? item.merchatInfo.companyName : '--';
        item.remainingAmount = (item.payableAmount - item.paidAmount).toFixed(2);
        item.countryVisaType = item.countryName + '-' + item.visaTypeName;
        return item;
      });
      const tHeader = ['客户名称', '商户名称', '订单号', '订单金额', '剩余收款', '人数', '下单时间', '国家-类型', '产品名称', '备注', '订单状态'];
      const filterVal = ['customerName', 'merchantName', 'orderNo', 'payableAmount', 'remainingAmount', 'num', 'createdTime', 'countryVisaType', 'visaTitle', 'marks', 'statusName'];
      const filename = '订单导出_' + new Date().getTime();
      const data = this.formatJson(filterVal, exportData);
      export_json_to_excel({
        header: tHeader,
        data,
        filename
      });
    },
    formatJson(filterVal, tableData) {
      return tableData.map((v) => {
        return filterVal.map((j) => {
          return (v[j] === 0 || v[j]) ? v[j] : '--';
        });
      });
    },
    handleAmountInput() {
      this.addReceiveForm.amount = this.addReceiveForm.amount.toString().replace(/[^\d.]/g, '');
      const parts = this.addReceiveForm.amount.split('.');
      if (parts.length > 2) {
        this.addReceiveForm.amount = parts[0] + '.' + parts.slice(1).join('');
      }
      if (parts[1] && parts[1].length > 2) {
        this.addReceiveForm.amount = parts[0] + '.' + parts[1].substring(0, 2);
      }
    },
    saveAddReceive() {
      this.$refs.addReceiveFormRef.validate(valid => {
        if (valid) {
          const submitData = {
            accountId: this.addReceiveForm.accountId,
            isPaid: true,
            remark: this.addReceiveForm.remark,
            imgUrl: this.addReceiveForm.imgUrl,
            datas:this.selectedItems.map(t=>{
              return {
                orderId:t.id,
                paidAmount:t.currentAmount,
              }
            })
          }
          batchaddretransactionrecord(submitData).then(res => {
            if (res.code == 1) {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.$emit('refresh');
              this.handleGetFailData()
              this.$refs.virtualTableRef.clearAllSelection()
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          });
          // addretransactionrecord(submitData).then(res => {
          //   if (res.code == 1) {
          //     this.$message({
          //       message: "操作成功！",
          //       type: "success",
          //     });
          //     this.$emit('refresh');
          //     this.handleGetFailData()
          //   } else {
          //     this.$message({
          //       message: res.msg,
          //       type: "warning",
          //     });
          //   }
          // });

          this.visibleAddReceive = false;
          this.addReceiveForm = {
            amount: '',
            accountId: '',
            remark: '',
          };
        } else {
          return false;
        }
      });
    },
    exportMethod(exportData) {
      const tHeader = ['申请人姓名', '护照号', '性别', '出生日期', '护照生效日期', '护照有效期', '申请人状态', '申请编号', '订单操作备注', '失败原因'] // 表格头部
      const filename = '申请人信息表'
      let data = exportData.map(item => {
        return [
          item.applicantName,
          item.passportNumber,
          item.genderName,
          item.birthDay,
          item.passportIssue,
          item.passportValidity,
          item.statusName,
          item.applyNumber,
          item.serviceMarks,
          item.latestStatus,
        ]
      })
      console.log(data);
      console.log(filename);
      console.log(tHeader);



      export_json_to_excel({
        header: tHeader,
        data,
        filename
      })
    },
    getAccountList() {
      getQueryaccount({
        "Page.Index": 1,
        "Page.Size": 9999,
      }).then(res => {
        this.accountList = res.data.rows.map(t => {
          return {
            label: t.accountName,
            value: t.id,
          };
        });
      });
    },
  },
  created() {
    this.getAccountList();
  },
};
</script>

<style lang="scss">
.export-dialog {

  .el-dialog {
    background-color: transparent;

    .el-dialog__header {
      display: none !important;
    }

    .el-dialog__body {
      background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
      border-radius: 12px;
      box-sizing: border-box;
      overflow: hidden;
    }
  }

  .dialog-member-content {
    padding: 10px;
  }
}
</style>